import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Grid from '@mui/material/Grid';
import BoltIcon from '@mui/icons-material/Bolt';

import Box from '@mui/material/Box'; // <-- Box component import
import Typography from '@mui/material/Typography'; // <-- Typography import
import TextField from '@mui/material/TextField'; // <-- TextField import
import InputAdornment from '@mui/material/InputAdornment'; // <-- InputAdornment import
import SearchIcon from '@mui/icons-material/Search'; // <-- SearchIcon import
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import ViewModuleIcon from '@mui/icons-material/ViewModule';


import styles from './style.module.css';
import ApiConfig from '../../utils/services/apiConfig'

import AddRobotModel from './add_robots_form'
import Robot from './robot'
import { useKeycloak } from '@react-keycloak/web';

import Config from '../../config';
import { formatRelativeLocalTime, toLocalDate } from '../../utils/dateTime';
import { useMountEffect } from '../../utils/hooks';


const ONLINE_THRESHOLD_MS = 2 * 60 * 1000;


export default function App() {
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const [robots, setRobots] = useState([]);
  const [, setHeight] = useState(window.innerHeight);
  const [, setWidth] = useState(window.innerWidth);
  const [open_new_robot_model, setOpenNewRobotModel] = useState(false);

    // Define searchText and handleSearch here
    const [searchText, setSearchText] = useState(''); // <-- searchText state
    const [filterType, setFilterType] = useState(''); // Define filterType
    const [filterSite, setFilterSite] = useState(''); // Define filterSite
    const [filterConnectionStatus, setFilterConnectionStatus] = useState(''); // Define online/offline filter
    const [robotTypes, setRobotTypes] = useState([]); // Store fetched robot types
    const [robotSites, setRobotSites] = useState([]); // Store fetched robot sites
    const [relativeTimes, setRelativeTimes] = useState({});
    const [overviewMode, setOverviewMode] = useState('detailed');



    const handleSearch = (event) => { // <-- handleSearch function
      setSearchText(event.target.value);
    };
  const handleAddRobotOpen = () => setOpenNewRobotModel(true);
  const handleAddRobotClose = () => setOpenNewRobotModel(false);


  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()
  // console.log("TOKEN IN DASHBOARD APP "+keycloak.token)

  useEffect(() => {
    const ws = new WebSocket(Config.robot_status_ws);

    ws.onopen = () => {
      console.log('Robot overview WebSocket connection established.');
    };

    ws.onclose = (event) => {
      console.log('Robot overview WebSocket connection closed.', event.code, event.reason);
    };

    ws.onerror = (error) => {
      console.error('Robot overview WebSocket error:', error);
    };

    ws.onmessage = (event) => {
      try {
        const obj = JSON.parse(event.data);

        if (obj.type === "status" && obj.data) {
          console.log(obj.data)
          setRobots((prevRobots) =>
            prevRobots.map((robot) =>
              robot.info.Id === obj.data.RobotTableId
                ? { ...robot, status: obj.data }
                : robot
            )
          );
        } else if (obj.type === "laser" && obj.data) {
          setRobots((prevRobots) =>
            prevRobots.map((robot) =>
              robot.info.Id === obj.data.RobotTableId
                ? { ...robot, laser: obj.data }
                : robot
            )
          );
        }
      } catch (error) {
        console.error('Robot overview WebSocket message parse error:', error);
      }
    };

    return () => {
      ws.close();
    };
  }, []);


function getLastStatusDate(robot) {
  if (!robot?.status?.CreatedAt) return null;
  return toLocalDate(robot.status.CreatedAt);
}

function isRobotOnline(robot) {
  const lastStatusDate = getLastStatusDate(robot);
  if (!robot?.info?.ActivationStatus || !lastStatusDate) return false;
  return Date.now() - lastStatusDate.getTime() <= ONLINE_THRESHOLD_MS;
}

function getSiteName(robot) {
  return robot?.info?.Site || 'Unassigned Site';
}

function getRobotTypeName(robot) {
  return robot?.info?.Type?.Name || robot?.info?.Type?.Type || robot?.info?.Type || 'Unknown Type';
}

function getBatteryLevel(robot) {
  const battery = Number(robot?.status?.BatteryLevel);
  if (!Number.isFinite(battery)) return 0;
  return Math.max(0, Math.min(100, battery));
}

function getBatteryColor(level) {
  if (level <= 20) return '#ef4444';
  if (level <= 50) return '#f59e0b';
  return '#22c55e';
}



// Fetch Robot Types and Sites for Dropdown Filters
const getFilterOptions = () => {
  Promise.all([
    apiConfig.fetchAllRobotTypes(),
    apiConfig.fetchAllRobotSites(),
  ])
    .then(([typesResult, sitesResult]) => {
      //console.log("Robot Types Response:", typesResult);  // Log the response for robot types
      //console.log("Robot Sites Response:", sitesResult);  // Log the response for robot sites

      if (typesResult.RobotResponse) {
        setRobotTypes(typesResult.RobotResponse); // Set robot types
      } else {
        //console.warn("No robot types data returned from API");
      }

      if (sitesResult.RobotResponse) {
        setRobotSites(sitesResult.RobotResponse); // Set robot sites
      } else {
        console.warn("No robot sites data returned from API");
      }
    })
    .catch(error => {
      console.error('Error fetching filter options:', error);
    });
};

  const handleManageRobot = (robot) => {
    navigate(`/robots/${robot.info.RobotId}`, { state: {robot_details: robot} })
  };

  const getRobotInfoById = (robot_info) => {
    Promise.all([
      apiConfig.fetchRobotType(robot_info.RobotTypeId),
      apiConfig.fetchRobotSite(robot_info.RobotSiteId),
      apiConfig.fetchRobotSoftwareVersion(robot_info.RobotSoftwareId),
      apiConfig.fetchRobotVersion(robot_info.RobotVersionId),
      apiConfig.fetchRobotStatus(robot_info.Id),
    ]).then(results => {
      robot_info["Type"] = results[0].RobotResponse
      robot_info["Site"] = results[1].RobotResponse.Site
      robot_info["Software"] = results[2].RobotResponse.Version
      robot_info["RobotVersion"] = results[3].RobotResponse.Version
      var robot = new Robot()
      robot.info = robot_info
      if(results[4]?.RobotResponse){
        robot.status = results[4].RobotResponse
      }
      setRobots((prevRobots) => ([
          ...prevRobots,
          robot
      ]))
      // if(results[4].RobotResponse){
      //   console.log(results[4].RobotResponse)
        // setRobotStatus((prevStatus) => ([
        //   ...prevStatus,
        //   results[4].RobotResponse
        // ]))
        // setRobotLaser((prevLaser) => ([
        //   ...prevLaser,
        //   {
        //     "RobotTableId": results[4].RobotResponse.RobotTableId,
        //     "CurrentPosition": {
        //       "Angle": 0,
        //       "X": 0,
        //       "Y": 0,
        //     },
        //     "RobotLaser": [
        //       {
        //         "X": 0,
        //         "Y": 0,
        //       }
        //     ],
        //   }
        // ]))
      // }
    }).catch(error => {
      console.error(error);
    });
  }

  const retrieveRobots = () => {
    setRobots([])
    // setRobotStatus([])
    // setRobotLaser([])
    Promise.all([
      apiConfig.fetchRobotData(0)
    ]).then(results => {
      var robot_table = results[0].RobotResponse
      for(let i = 0; i < robot_table.length; i++) {
        getRobotInfoById(robot_table[i])
      }
    }).catch(error => {
        console.error(error);
    });
  }

  const addRobots = (robot) => {
    apiConfig.registerRobot(robot).then((response)=>{
      console.log(response)
      retrieveRobots()
    })
  }



  const handleResize = ()=>{
    setWidth(window.innerWidth)
    setHeight(window.innerHeight)
  }

   // console.log(robotStatus)
    // console.log(robot)


    useMountEffect(() => {
      getFilterOptions();  // Call getFilterOptions on component mount
      retrieveRobots();
      setWidth(window.innerWidth);
    setHeight(window.innerHeight);
      window.addEventListener('resize', handleResize);
    }, []);


    useEffect(() => {
      const interval = setInterval(() => {
        setRelativeTimes((prevTimes) => {
          const updatedTimes = {};
          robots.forEach(robot => {
            if (robot.status.CreatedAt) {
              updatedTimes[robot.info.RobotId] = formatRelativeLocalTime(robot.status.CreatedAt);
            }
          });
          return updatedTimes;
        });
      }, 1000); // Update every second

      return () => clearInterval(interval); // Clean up interval on unmount
    }, [robots]);



    // Render each robot's "Last Updated" time


    //const CreatedAt = "2024-11-05T13:28:12.452Z"; // Example timestamp from data
   //const createdAtDate = new Date(CreatedAt); // Using the correct variable name
   //console.log("Timezone offset in minutes:", createdAtDate.getTimezoneOffset()); (Verifying the )


  const applyFilters = (robot) => {
    const robotType = getRobotTypeName(robot).toLowerCase(); // Human-readable type
    const robotSite = getSiteName(robot).toLowerCase(); // Ensure robot site is lowercased for comparison

    // Check if the robot matches the selected filter type (case-insensitive)
    const matchesTypeFilter = filterType ? robotType === filterType.toLowerCase() : true;

    // Check if the robot matches the selected site (case-insensitive)
    const matchesSiteFilter = filterSite ? robotSite === filterSite.toLowerCase() : true;

    const matchesConnectionStatusFilter = filterConnectionStatus
      ? (filterConnectionStatus === 'online' ? isRobotOnline(robot) : !isRobotOnline(robot))
      : true;

    // Return robots that match both type and site filters
    return matchesTypeFilter && matchesSiteFilter && matchesConnectionStatusFilter;
  };


  const visibleRobots = robots.filter(robot => {
    const robotId = robot.info.RobotId.toLowerCase();
    const robotType = getRobotTypeName(robot).toLowerCase();
    const robotSite = getSiteName(robot).toLowerCase();
    const searchQuery = searchText.toLowerCase();

    const matchesSearch = robotId.includes(searchQuery) ||
                          robotType.includes(searchQuery) ||
                          robotSite.includes(searchQuery);

    return matchesSearch && applyFilters(robot);
  });

  const robotsBySite = visibleRobots.reduce((groups, robot) => {
    const site = getSiteName(robot);
    if (!groups[site]) {
      groups[site] = [];
    }
    groups[site].push(robot);
    return groups;
  }, {});

  const sortedSiteNames = Object.keys(robotsBySite).sort((a, b) => a.localeCompare(b));

  const renderRobots = (robot, index) => {
    const online = isRobotOnline(robot);
    const lastUpdated = relativeTimes[robot.info.RobotId] || 'No status yet';

    return (
    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
      <div
        onClick={() => handleManageRobot(robot)}
        className={`${styles.robotCardContent} ${online ? styles.robotCardOnline : styles.robotCardOffline}`}
      >
        <div className={styles.robotInfo}>
          <div className={online ? styles.statusBadgeOnline : styles.statusBadgeOffline}>
            <span className={styles.statusDot}></span>
            {online ? 'Online' : 'Offline'}
          </div>
          <div className={styles.robotId}>{robot.info.RobotId}</div>
          <div>Type: {getRobotTypeName(robot)}</div>

          {/* Consistent Battery Bar */}
          <div
            style={{
              width: '100px',                 // Fixed width for all battery bars
              height: '20px',                 // Fixed height for all battery bars
              backgroundColor: 'var(--muted-bg, #d1d1d1)',  // Base color for empty battery
              borderRadius: '5px',            // Rounded corners for styling
              display: 'flex',
              alignItems: 'center',           // Center content vertically
              justifyContent: 'center',       // Center content horizontally
              margin: '0 auto',               // Center the battery bar itself
              boxSizing: 'border-box',
            }}
          >
            {/* Inner Div to handle the color and gradient */}
            <div
              style={{
                width: '100%',
                height: '100%',
                borderRadius: '5px',
                background: `linear-gradient(to right, ${
                  robot.status.BatteryLevel <= 50 && robot.status.BatteryLevel > 35
                    ? "#FFFF40"
                    : robot.status.BatteryLevel <= 35
                    ? "#FF5040"
                    : "#40FF55"
                } ${robot.status.BatteryLevel}%, #d1d1d1 0%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {/* Container for Icon and Percentage Text */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  fontSize: '0.85rem',        // Consistent font size
                  lineHeight: '1rem',
                }}
              >
                {/* BoltIcon with controlled size */}
                {robot.status.Charging && (
                  <BoltIcon
                    style={{
                      fontSize: '1rem',       // Smaller size for consistent look
                      width: '1rem',
                      height: '1rem',
                    }}
                  />
                )}
                {/* Battery Percentage Text */}
                <div style={{ fontSize: '0.85rem', lineHeight: '1rem' }}>{robot.status.BatteryLevel}%</div>
              </div>
            </div>
          </div>

          <div>Site: {robot.info.Site}</div>
          <div>Status: {robot.info.ActivationStatus ? robot.status.Status : "Robot not activated"}</div>
          <div>Last Updated: {lastUpdated}</div>
        </div>
        <div className={styles.robotImage}>
          <img src={`data:image/jpeg;base64,${robot.info.Type.Image}`} alt="robot" />
        </div>
      </div>
    </Grid>
    );
  };

  const renderSimpleRobot = (robot, index) => {
    const online = isRobotOnline(robot);
    const batteryLevel = getBatteryLevel(robot);
    const batteryColor = getBatteryColor(batteryLevel);
    const siteName = getSiteName(robot);
    const image = robot?.info?.Type?.Image;

    return (
      <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={robot.info.Id || robot.info.RobotId || index}>
        <button
          type="button"
          onClick={() => handleManageRobot(robot)}
          className={styles.simpleRobotCard}
        >
          <div className={styles.simpleRobotTop}>
            <span className={styles.simpleRobotName}>{robot.info.RobotId}</span>
            <span className={online ? styles.simpleStatusOnline : styles.simpleStatusOffline}>
              <span className={styles.statusDot}></span>
              {online ? 'Online' : 'Offline'}
            </span>
          </div>

          <div className={styles.simpleRobotImage}>
            {image && <img src={`data:image/jpeg;base64,${image}`} alt={robot.info.RobotId} />}
          </div>

          <div className={styles.simpleRobotSite}>
            Site: <span>{siteName}</span>
          </div>

          <div className={styles.simpleBatteryRow}>
            <BatteryChargingFullIcon sx={{ fontSize: '1.1rem', color: batteryColor }} />
            <span className={styles.simpleBatteryValue}>{batteryLevel}%</span>
          </div>
          <div className={styles.simpleBatteryTrack}>
            <div
              className={styles.simpleBatteryFill}
              style={{ width: `${batteryLevel}%`, backgroundColor: batteryColor }}
            ></div>
          </div>
        </button>
      </Grid>
    );
  };





  return (
    <div className={styles.container}>
      {/* Add the "Deployed Robot Overview" header */}
      <Box display="flex" justifyContent="center" mb={2}>
        <Typography
          variant="h3"
          sx={{
            fontFamily: "Franklin Gothic",
            fontWeight: 'bold',
            fontSize: '45px',
            color: 'text.primary',
            marginLeft: '15px'
          }}
        >
          Deployed Robot Overview
        </Typography>
      </Box>


      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4} flexDirection={{ xs: 'column', sm: 'row' }}>
  {/* Left side: Filter buttons */}
  <Box display="flex" gap={2} alignItems="center" flexDirection={{ xs: 'column', sm: 'row' }} mb={{ xs: 2, sm: 0 }} width="100%">
    {/* Filter by Robot Type Dropdown */}
    <FormControl variant="outlined" sx={{
      width: { xs: '100%', sm: 180 },
      backgroundColor: 'background.paper',
      borderRadius: '5px',
      position: 'relative',
      // Shift to the right only on larger screens (above 600px, typically tablet and desktop)
      '@media (min-width: 600px)': {
        left: '-9px', // Adjust this value to move further right as needed
      },

      }}>
      <InputLabel>All Robot Type</InputLabel>
      <Select
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
        label="Filter by Robot Type"
        sx={{ height: '50px', width: '100%' }}
      >
            <MenuItem value="">All Types</MenuItem>
            {robotTypes.map(type => (
              <MenuItem key={type.Id} value={type.Name}>{type.Name}</MenuItem>
            ))}
      </Select>
    </FormControl>

    <FormControl variant="outlined" sx={{ width: { xs: '100%', sm: 240 }, backgroundColor: 'background.paper', borderRadius: '5px' }}>
  <InputLabel>All Sites</InputLabel>
  <Select
    value={filterSite}
    onChange={(e) => setFilterSite(e.target.value)}
    label="Filter by Site"
    sx={{ height: '50px', width: '100%' }}
  >
    <MenuItem value="">All Sites</MenuItem>
    {robotSites.length > 0 ? (
      robotSites.map(site => (
        <MenuItem key={site.Id} value={site.Site}>{site.Description}</MenuItem>
      ))
    ) : (
      <MenuItem disabled>No sites available</MenuItem>
    )}
  </Select>
</FormControl>

    <FormControl variant="outlined" sx={{ width: { xs: '100%', sm: 180 }, backgroundColor: 'background.paper', borderRadius: '5px' }}>
      <InputLabel>All Status</InputLabel>
      <Select
        value={filterConnectionStatus}
        onChange={(e) => setFilterConnectionStatus(e.target.value)}
        label="Filter by Status"
        sx={{ height: '50px', width: '100%' }}
      >
        <MenuItem value="">All Status</MenuItem>
        <MenuItem value="online">Online</MenuItem>
        <MenuItem value="offline">Offline</MenuItem>
      </Select>
    </FormControl>



</Box>

<TextField
  variant="outlined"
  placeholder="Search robots"
  value={searchText} // Bind the input value to the searchText state
  onChange={handleSearch} // Use the handleSearch function to update searchText
  sx={{
    width: { xs: '100%', sm: '300px' },  // Make the search bar responsive
    backgroundColor: 'background.paper',
    borderRadius: '5px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '5px',
      height: '50px',
    },

    // Shift the search bar slightly to the right for larger screens
    position: 'relative',
    '@media (min-width: 992px)': {
      right: '14px', // Adjust this value to control the shift to the right
    },

  }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon />
      </InputAdornment>
      ),
    }}
  />
</Box>

<Box className={styles.viewToggleBar}>
  <ButtonGroup variant="outlined" size="small" aria-label="Robot overview view mode">
    <Button
      startIcon={<DashboardIcon />}
      onClick={() => setOverviewMode('detailed')}
      variant={overviewMode === 'detailed' ? 'contained' : 'outlined'}
    >
      Site View
    </Button>
    <Button
      startIcon={<ViewModuleIcon />}
      onClick={() => setOverviewMode('battery')}
      variant={overviewMode === 'battery' ? 'contained' : 'outlined'}
    >
      Grid View
    </Button>
  </ButtonGroup>
</Box>

<div key={overviewMode} className={styles.viewTransition}>
  {overviewMode === 'detailed' ? (
    sortedSiteNames.length > 0 ? (
      sortedSiteNames.map((siteName) => {
        const siteRobots = robotsBySite[siteName];
        const onlineCount = siteRobots.filter(isRobotOnline).length;
        const offlineCount = siteRobots.length - onlineCount;

        return (
          <Box key={siteName} className={styles.siteSection}>
            <Box className={styles.siteHeader}>
              <Typography variant="h5" className={styles.siteTitle}>
                {siteName}
              </Typography>
              <Box className={styles.siteStatusSummary}>
                <span className={styles.siteCount}>{siteRobots.length} robots</span>
                <span className={styles.onlineSummary}>{onlineCount} online</span>
                <span className={styles.offlineSummary}>{offlineCount} offline</span>
              </Box>
            </Box>
            <Grid
              container
              spacing={3}
              className={`${styles.gridContainer} ${styles.siteCardsGrid}`}
              sx={{ margin: 0, width: '100%' }}
            >
              {siteRobots.map((robot, index) => renderRobots(robot, `${siteName}-${robot.info.Id || index}`))}
            </Grid>
          </Box>
        );
      })
    ) : (
      <Box className={styles.emptyRobots}>
        No robots match the current filters.
      </Box>
    )
  ) : (
    visibleRobots.length > 0 ? (
      <Grid
        container
        spacing={2}
        justifyContent="center"
        className={`${styles.gridContainer} ${styles.simpleGrid}`}
        sx={{ margin: 0, width: '100%' }}
      >
        {visibleRobots.map((robot, index) => renderSimpleRobot(robot, index))}
      </Grid>
    ) : (
      <Box className={styles.emptyRobots}>
        No robots match the current filters.
      </Box>
    )
  )}
</div>

<Grid container spacing={3} justifyContent="center" className={styles.gridContainer}>
  <Grid item xs={12}>
  <Box
      onClick={handleAddRobotOpen}
      className={styles.addRobot}
      sx={{
        cursor: 'pointer',
        padding: '10px 20px',
        backgroundColor: 'background.paper',
        color: 'text.secondary',
        borderRadius: '5px',
        textAlign: 'center',
        fontWeight: 'bold',
        width: { xs: '100%', sm: 'auto' }, // Full width on small screens, auto on larger screens
        transform: { xs: 'scale(1)', sm: 'scale(0.975)' }, // Scales down to 90% on larger screens

        '@media (max-width: 599px)': { // Mobile-specific styling
          fontSize: '16px', // Slightly larger text on mobile
          marginBottom: '10px', // Adds spacing below for mobile layout
          marginLeft: '-11px',

        },

        '@media (min-width: 600px)': {
          marginLeft: '-19px', // Adjust as needed for 14-inch and 27-inch
        },
      }}
    >
      Add New Robot
    </Box>  </Grid>
</Grid>

<AddRobotModel apiConfig={apiConfig} handleClose={handleAddRobotClose} open_new_robot={open_new_robot_model} addRobots={addRobots} />

    </div>
  );
}
